import {DropdownOptionProps} from '../../../models/DropdownProps';
import {SELECT_LANGUAGE} from '../../../utils/DropdownOptionPropsUtils';

export const languageResource: DropdownOptionProps[] = [
    {
        name: SELECT_LANGUAGE, value: SELECT_LANGUAGE
    },
    {
        name: 'German', value: 'de'
    },
    {
        name: 'English', value: 'en'
    },
    {
        name: 'Spanish', value: 'es'
    },
    {
        name: 'French', value: 'fr'
    },
    {
        name: 'Italian', value: 'it'
    },
    {
        name: 'Polish', value: 'pl'
    },
    {
        name: 'Dutch', value: 'nl'
    },
    {
        name: 'Portuguese', value: 'pt'
    },
    {
        name: 'Hindi', value: 'hi'
    },
    {
        name: 'Chinese', value: 'zh'
    },
    {
        name: 'Japanese', value: 'ja'
    },
    {
        name: 'Korean', value: 'ko'
    },
    {
        name: 'Danish', value: 'da'
    },
    {
        name: 'Bulgarian', value: 'bg'
    },
    {
        name: 'Czech', value: 'cs'
    },
    {
        name: 'Greek', value: 'el'
    },
    {
        name: 'Estonian', value: 'et'
    },
    {
        name: 'Finnish', value: 'fi'
    },
    {
        name: 'Hungarian', value: 'hu'
    },
    {
        name: 'Lithuanian', value: 'lt'
    },
    {
        name: 'Latvian', value: 'lv'
    },
    {
        name: 'Norwegian', value: 'no'
    },
    {
        name: 'Romanian', value: 'ro'
    },
    {
        name: 'Serbian', value: 'sr'
    },
    {
        name: 'Swedish', value: 'sv'
    },
    {
        name: 'Turkish', value: 'tr'
    }
];
